import HTTP from '@pillarjs/http';
import { Message as ElMessage } from 'element-ui';
import Store from '@/store/';
import Router from '../router/router';
import { toLogin } from '@/utils/helpers';

/**
 * 关闭所有 loading
 */
const closeLoadings = () => {
  Store.commit('loading/UPDATE_GLOBAL_LOADING', false);
  Store.commit('loading/UPDATE_CONTENT_LOADING', false);
};

const httpInstance = new HTTP({
  baseURL: process.env.VUE_APP_BASE_URL_API,
  //headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
  // @TODO: 如果后端接口有优化，此值应该改小
  timeout: 300000,
  // 允许携带 cookie
  withCredentials: true
});

//请求拦截器
httpInstance.useRequestInterceptor(config => {
  config.showLoading = config.hasOwnProperty('showLoading') ? config.showLoading : false;
  config.loadingType = config.hasOwnProperty('loadingType') ? config.loadingType : 'content';
  config.showError = config.hasOwnProperty('showError') ? config.showError : true;
  config.errorMsg = config.hasOwnProperty('errorMsg') ? config.errorMsg : '网络异常，请稍后重试';

  if (config.showLoading) {
    const relations = {
      content: 'loading/UPDATE_CONTENT_LOADING',
      global: 'loading/UPDATE_GLOBAL_LOADING'
    };
    Store.commit(relations[config.loadingType], true);
  }

  // 如果能获取到用户 token，则每次发送请求时都要携带
  if (Store.state.user.token) {
    config.headers['x-auth-token'] = `${Store.state.user.token}`;
  }

  return config;
});

//响应拦截器
httpInstance.useResponseInterceptor(
  res => {
    //res.data.code = 'fail.param.error.ConnToken'
    if (res.data.code === 'fail.login') {
      location.replace('/login');
      return;
    }
    else if(res.data.code === 'fail.param.error.ConnToken' && Store.state.source.currentSource){
      toLogin(Router, Store.state.source.sourceInfo);
      return;
    }
    return Promise.resolve(res);
  },
  err => {
    /**
     * 处理异常
     */
    if (err.response) {
      // 开发环境下打印错误日志
      if (process.env.NODE_ENV === 'development') {
        console.error('HTTP REQUEST ERROR!');
        console.warn('--- Log Start ---');
        console.log(err.response);
        console.warn('--- Log End ---');
      }
    }
    return Promise.reject(err.response);
  }
);

const install = Vue => {
  Object.defineProperty(Vue.prototype, '$http', { value: httpInstance });
};

export const http = httpInstance;

export default install;
